import React, { lazy } from 'react';
import { Route, Redirect } from 'react-router-dom';

const Expired = lazy(() =>
  import(/* webpackChunkName: "Expired" */ '../containers/common/Expired')
);
const Quote = lazy(() => import(/* webpackChunkName: "Quote" */ '../containers/Quote'));
/* istanbul ignore next */
const Analysis = lazy(() => {
  return import(/* webpackChunkName: "Analysis" */ '../containers/common/Analysis/Analysis');
});

export default () => {
  return [
    <Route exact path="/quote/result/expired" component={Expired} key="quote-expired" />,
    <Route exact path="/cotacao/em-analise/:errorCode?" component={Analysis} key="em-analise" />,
    <Route
      exact
      path="/retomar-cotacao"
      render={({ location }) => {
        return <Redirect to={{ ...location, pathname: '/cotacao/resultado' }} />;
      }}
    />,
    <Route exact path="/cotacao/:id/:appended?" component={Quote} key="quote-single" />,
    <Route exact path="/" component={Quote} key="quote" />,
  ];
};
